export default __webpack_public_path__ + "static/media/menu_manage_icon.b09c7efb.svg";